<template>
    <div>
        <modal :show.sync="openFCI" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <div v-if="pymeMessage != null" class="alert alert-info">
                        <span>El valor actual del sistema es:<strong> {{ pymeMessage }}</strong></span>
                    </div>  
                    <p-button @click="saveCostsPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Aceptar</p-button>
                    </div>
                </template>       
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="productPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Quincenal"
                                    label="Quincenal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="productPeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="checkboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="checkboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="checkboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="checkboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="checkboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="workdaysComputed != 0" class="alert alert-warning">
                        <span>Trabaja {{workdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in checkboxesComputed" :key="workday.day" class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Semanal'">
                    <div v-for="weekday in weeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Quincenal'">
                    <div v-for="biweek in biweeks" :key="biweek.biweek" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Quincena {{biweek.biweek}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="biweek.biweek" v-validate="modelValidations.sales" :error="getError(biweek.biweek)" separator="." class="form-control" v-model="biweek.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="productPeriodicity == 'Mensual'">
                    <div class="form-group">
                        <label>Mes</label>
                        <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="mes" v-validate="modelValidations.sales" :error="getError('mes')" separator="." class="form-control" v-model="productMonth"></vue-numeric>
                    </div>
                </div>
                <div class="form-group">
                    <label>Promedio producción *</label>
                    <fg-input   disabled
                                tabindex="1"
                                type="number"
                                name="promedio mes"
                                placeholder="promedio mes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio mes')"
                                v-model="monthlyAverageComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta unitario*</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>-->
                <div v-if="productTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productTotalSaleComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="productTotalSaleComputed != 0" type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ítem</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="3"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('detalle')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="4" currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemValue "></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar ítem</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('detalle')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="6" currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemValue "></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editItemToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <card v-if="switches.product" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Costeo por ítem</h6>
                <p-button v-if="pyme" class="top-right-button" type="primary" @click="openFCIMethod()">FCI</p-button>
            </div>
            <div class="card-body">
                <el-table v-if="products_computed.length" :data="products_computed"  ref="productsTable"  @row-dblclick="editProductLineMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <!--<p>Producto: {{ props.row.productName }}</p>-->
                            <p>Periodicidad: {{ props.row.productPeriodicity }}</p>
                            <p>Promedio al mes: {{ props.row.productSaleMonthly }}</p>
                            <p>Precio venta: {{ setFormat(props.row.productSaleValue) }}</p>
                            <p>% part: {{ props.row.productPartPercent }}</p>
                            <!--<p>Total: {{ setFormat(props.row.productTotalSale) }}</p>-->
                            <!-- <p>Costo %: {{ Math.round(props.row.productCostPercent) }}</p> -->
                            <!-- <div class="form-group">
                                <label>Tipo de costeo de insumos *</label>
                                <fg-input   tabindex="3"
                                            name="tipo de costeo"
                                            v-validate="modelValidations.product_name"
                                            :error="getError('tipo de costeo')"
                                            v-model="props.row.productSelect">
                                        <el-select 
                                                @change="validateProductSelect(props.row.id)"
                                                class="select-warning"
                                                size="large"
                                                placeholder="Seleccione..."
                                                v-model="props.row.productSelect">
                                        <el-option class="select-warning"
                                                value="unit"
                                                label="Individual">
                                        </el-option>
                                        <el-option class="select-warning"
                                                value="total"
                                                label="Total">
                                        </el-option>
                                    </el-select>
                                </fg-input>
                            </div> -->
                            <div class="form-group">
                                <label>Unidades a costear</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="unidades" @input="validateProductUnitCosting(props.row)" v-validate="modelValidations.sales" :error="getError('unidades')" separator="." class="form-control" v-model="props.row.productUnitCosting"></vue-numeric>
                            </div>
                            <h5 v-if="props.row.items.length > 0" style="color: #FFA20B;">Insumos</h5>
                            <el-table ref="itemsTable" highlight-current-row @current-change="handleCurrentItemChange" v-if="props.row.items.length > 0" :data="props.row.items">
                                <el-table-column label="Ítem" property="itemName"></el-table-column>
                                <el-table-column label="Valor">
                                    <template slot-scope="scope">
                                        <span >{{ setFormat(scope.row.itemValue )}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br>
                            <div v-if="props.row.items.length < 10">
                                <p-button 
                                    @click="addItemMethod(props.$index)"
                                    type="default" 
                                    >
                                    <i class="mr-2 fa fa-plus"></i>Agregar ítem
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="editItemMethod(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-pencil"></i>Editar ítem
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="removeItem(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-minus"></i>Quitar ítem
                                </p-button>
                            </div>
                            <div v-if="props.row.productSelect == 'unit'" class="alert alert-info mt-2">
                                <span>Venta del costeo: {{ setFormat(props.row.productSalesCosting) }}</span>
                            </div>
                            <div v-if="props.row.productSelect == 'total'" class="alert alert-info mt-2">
                                <span>Venta del costeo: {{ setFormat(props.row.productSalesCosting) }}</span>
                            </div>
                            <div  class="alert alert-warning mt-2">
                                <span>Total: {{ setFormat(totalItemsCosting(props.row)) }}</span>
                            </div>
                            <div  class="alert alert-warning mt-2">
                                <span>Costo unitario: {{ setFormat(totalUnitCosting(props.row)) }}</span>
                            </div>
                            <div  class="alert alert-warning mt-2">
                                <span>Costo mensual: {{ setFormat(totalCosting(props.row)) }}</span>
                            </div>
                            <div  class="alert alert-warning mt-2">
                                <span>% Costo: {{Math.round(props.row.productCostPercent)}}%</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Producto" property="productName"></el-table-column>
                    <el-table-column label="Venta">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.productTotalSale)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <collapse v-for="product in products" :key="product.productLineName">
                    <collapse-item :title="product.productLineName+' - '+ setFormat(product.productLineTotal) + ' - ' + productPercent(product.productLineTotal) + '%'" :name="product.productLineName">
                    <div>
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                    </collapse-item>
                </collapse> -->
                <div>
                    <p-button
                        v-if="!validateLocked() && products_computed.length < 10" 
                        :disabled="validateLocked()"
                        @click="addProductLineMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar ítem
                    </p-button>
                    <br>
                    <p-button v-if="currentRow && !validateLocked()"
                    
                        :disabled="validateLocked()"
                        @click="editProductLineMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar ítem
                    </p-button>
                    <br>
                    <p-button v-if="currentRow && !validateLocked()"
                        :disabled="validateLocked()"
                        @click="removeProductLineMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar ítem
                    </p-button>
                </div>
                <div v-if="products_percent_computed != 0" class="alert alert-warning mt-2">
                    <span>Porcentaje promedio: {{Math.round(products_percent_computed)}}%</span>
                </div>
                <div v-if="products_percent_computed != 0" class="alert alert-warning mt-2">
                    <span>Ventas: {{setFormat(products_sales_computed)}}</span>
                </div>
                <!-- <div v-if="products_costs_monthly_average != 0" class="alert alert-warning mt-2">
                    <span>Promedio costos mensual: {{setFormat(Math.round(products_costs_monthly_average))}}</span>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div v-if="products_costs_monthly_average != 0" class="alert alert-success">
            <span>Promedio costos mensual: {{setFormat(Math.round(products_costs_monthly_average))}}</span>
        </div>
        <div v-if="this.$store.state.isCustomer && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isSpouse && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isGuarantor && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales)}}</span>
        </div>
        <div class="text-right">
            <p-button v-if="validateSwitch()" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toCostsItemGeneralSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            pyme: false,
            openFCI: false,
            pymeMessage: null,
            form: {
                average_selection: '',
            },
            productSelect: 'unit',
            currentRow: null,
            currentItemRow: null,
            itemName: '',
            itemValue : '',
            editProduct: false,
            addItem: false,
            editItem: false,
            addItemIndex: null,
            editItemIndex: null,
            items: [
                
            ],
            productName: '',
            productPeriodicity: '',
            productSaleValue: '',
            productMonth: '',
            productSaleMonthly: '',
            productTotalSale: '',
            productCostPercent: 0,
            productSelect: 'unit',
            productMultiplier: 1,
            productDailyCheckboxes: false,
            switches: {
                daily: false,
                weekly: false,
                monthly: false,
                product: true,
                average: false,
            },
            checkboxes: [],
            weeks: [],
            biweeks: [],
            months: [
                {
                    month: '1',
                    sales: ''
                },
                {
                    month: '2',
                    sales: ''
                },
                {
                    month: '3',
                    sales: ''
                }
            ],
            addProduct: false,
            products: [
                
            ],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: false
                },
                sales: {
                    required: false,
                    max: 32
                },
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
                product_name: {
                    required: false,
                    max: 32
                },
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productPeriodicity: function (val) {
                if (this.editProduct == true) {
                    if (val == 'Diaria') {
                        this.resetWeeks();
                        this.resetBiWeeks();
                        this.productMonth= '';
                    }
                    else if (val == 'Semanal') {
                        this.resetCheckboxes();
                        this.resetBiWeeks();
                        this.productMonth= '';
                    }
                    else if (val == 'Quincenal') {
                        this.resetCheckboxes();
                        this.resetWeeks();
                        this.productMonth= '';
                    }
                    else if (val == 'Mensual') {
                        this.resetCheckboxes();
                        this.resetWeeks();
                        this.resetBiWeeks();
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productSelect: function(val) {
                if (val == 'unit') {
                    this.productMultiplier = 1;
                }
                else {
                    this.productMultiplier = 1;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLinePurchaseCost: function (val) {
                if (val != 0) {
                    if (this.productLineMonthly != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLineMonthly);
                        this.productLineTotalFormat = this.setFormat(this.productLineTotal);
                        this.productLinePurchaseCostFormat = this.setFormat(val);
                    }
                }
                else {
                    this.productLineTotal = 0;
                    this.productLineTotalFormat = 0;
                    this.productLinePurchaseCostFormat = 0;

                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLineMonthly: function (val) {
                if (val != 0) {
                    if (this.productLinePurchaseCost != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLinePurchaseCost)
                    }
                }
                else {
                    this.productLineTotal = 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdaysComputed: function (val) {
                if (this.switches.product && val > 0 && this.productDaily != 'NaN' && this.productDaily != '') {
                    this.productWeekly = parseFloat(val) * parseFloat(this.productDaily);
                }
                else if (val == 0) {
                    this.productWeekly = 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productDaily: function (val) {
                if (!this.switches.daily) {
                    this.productDailyCheckboxes = true;
                }
                else {
                    this.productDailyCheckboxes = false;
                }
                if (this.workdaysComputed > 0 && val != 'NaN' && val != '') {
                    this.productWeekly = parseFloat(val) * this.workdaysComputed;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productWeekly: function (val) {
                if (val != 'NaN' && val != '') {
                    this.productMonthly = parseFloat(val) * 4;  
                }
                else if (val != 'NaN' && val == '') {
                    this.productMonthly = '';
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthly: function (val) {
                if (this.productValue != 0 && val != '') {
                    this.productMonthlyValue = parseFloat(val) * this.productValue;
                } 
                else {
                    this.productMonthlyValue = 0;
                }  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValue: function (val) {
                if (this.productMonthly != '' && this.productMonthly != 'NaN') {
                    this.productMonthlyValue = val * parseFloat(this.productMonthly);
                }
                else {
                    this.productMonthlyValue = 0;
                }
            }
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_computed () {
                var percent = 0;
                for (let i=0;i<this.products.length;i++) {
                    var sum = 0;
                    for (let j=0;j<this.products.length;j++) {
                        sum = sum + this.products[j].productTotalSale;
                    }
                    if (sum != 0) {
                        this.products[i].productPartPercent = Math.round(parseFloat(this.products[i].productTotalSale) * 100 / sum);
                    }
                }
                return this.products;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            monthlyAverageComputed () {
                var sum = 0;
                var total = 0;
                if (this.productPeriodicity == 'Diaria') {
                    for (var i=0; i<this.checkboxesComputed.length; i++) {
                        if (this.checkboxesComputed[i].sales != '') {
                            sum = sum + parseFloat(this.checkboxesComputed[i].sales)
                            total = sum * 4
                        }
                    }
                }
                else if (this.productPeriodicity == 'Semanal') {
                    for (var i=0; i<this.weeks.length; i++) {
                        if (this.weeks[i].sales != '') {
                            sum = sum + parseFloat(this.weeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.productPeriodicity == 'Quincenal') {
                    for (var i=0; i<this.biweeks.length; i++) {
                        if (this.biweeks[i].sales != '') {
                            sum = sum + parseFloat(this.biweeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.productPeriodicity == 'Mensual') {
                    total = this.productMonth;
                }
                this.productSaleMonthly = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productTotalSaleComputed () {
                var total = this.productSaleMonthly * this.productSaleValue;
                this.productTotalSale = total;
                return total;

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_costs_monthly_average () {
                var total = 0;
                var sum = 0;
                if(this.$store.state.isCustomer) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        for (let i=0;i<this.products.length;i++) {
                            sum = sum + Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales * (this.products[i].productPartPercent / 100) * (this.products[i].productCostPercent / 100));
                        }
                        // total = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales * (this.products_percent_computed/100);
                        return sum
                    }
                }
                else if(this.$store.state.isSpouse) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        for (let i=0;i<this.products.length;i++) {
                            sum = sum + Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales * (this.products[i].productPartPercent / 100) * (this.products[i].productCostPercent / 100));
                        }
                        // total = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales * (this.products_percent_computed/100);
                        return sum
                    }
                }
                else if(this.$store.state.isGuarantor) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        for (let i=0;i<this.products.length;i++) {
                            sum = sum + Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales * (this.products[i].productPartPercent / 100) * (this.products[i].productCostPercent / 100));
                        }
                        // total = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales * (this.products_percent_computed/100);
                        return sum
                    }
                }
                // for (let i=0;i<this.products.length;i++) {
                //     total = total + this.products[i].productTotalCost;
                // }
                return total
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_percent_computed () {
                var sum = 0;
                var avg = 0;
                for (let i=0; i<this.products.length;i++) {
                    sum = sum + this.products[i].productCostPercent;
                }
                if (sum != 0) {
                    avg = sum / this.products.length;
                }
                return avg
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            item_percent_computed () {
                var percent = 0;
                if (this.itemPurchasePrice != 0 && this.itemSalePrice != 0) {
                    percent =  Math.round((this.itemPurchasePrice * 100) / this.itemSalePrice);
                }
                this.itemPercent = percent;
                return percent;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_costs_computed () {
                if(this.$store.state.isCustomer) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        for (let i=0;i<this.products.length;i++) {
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = sum + productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                else if(this.$store.state.isSpouse) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        for (let i=0;i<this.products.length;i++) {
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = sum + productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                else if(this.$store.state.isGuarantor) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        for (let i=0;i<this.products.length;i++) {
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = sum + productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_sales_computed () {
                var sum = 0;
                if (this.products) {
                    for (var i=0;i<this.products.length;i++) {
                        sum = sum + parseFloat(this.products[i].productTotalSale);
                    }
                }
                return sum;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_sales_computed () {
                return (this.average.good_sale + this.average.regular_sale + this.average.bad_sale) / 3;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_monthly_sales_computed () {
                var sum = 0;
                var total = 0;
                if (this.form.average_selection == 'diaria') {
                    return this.average_sales_computed * this.workdaysComputed * 4;
                }
                else if (this.form.average_selection == 'semanal') {
                    return this.average_sales_computed * 4;
                }
                else if (this.form.average_selection == 'mensual') {
                    return this.average_sales_computed;
                }
                else {
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdaysComputed () {
                return this.checkboxes.filter(day => day.value == true).length;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            checkboxesComputed () {
                return this.checkboxes.filter(day => day.value == true);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_sales_computed () {
                var sum = 0;
                var total = 0;
                for (var i=0; i<this.checkboxesComputed.length; i++) {
                    if (this.checkboxesComputed[i].sales != '') {
                        sum = sum + parseFloat(this.checkboxesComputed[i].sales)
                        total = sum * 4
                    }
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            weekdays_sales_computed () {
                var sum = 0;
                var total = 0;
                for (var i=0; i<this.weeks.length; i++) {
                    if (this.weeks[i].sales != '') {
                        sum = sum + parseFloat(this.weeks[i].sales)
                        total = sum
                    }
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            months_sales_computed () {
                var sum = 0;
                var avg = 0;
                for (var i=0; i<this.months.length; i++) {
                    if (this.months[i].sales != '') {
                        sum = sum + parseFloat(this.months[i].sales)
                        avg = sum / this.months.length
                    }
                }
                return avg;
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setPymeCostsDescription (description) {
                this.pymeMessage = description;
                this.$store.commit('updateCustomerPECosts', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveCostsPymeData (description) {
                this.setPymeCostsDescription(description);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            openFCIMethod(){
                this.openFCI = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelOpenFCI(){ 
                this.openFCI = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             productValidator (product) {
                if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pyme = true;
                }
             },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetCheckboxes () {
                this.checkboxes= [
                    {
                        day: "Lunes",
                        char: "L",
                        value: true,
                        sales: ''
                    },
                    {
                        day: "Martes",
                        char: "M",
                        value: true,
                        sales: ''
                    },
                    {
                        day: "Miércoles",
                        char: "M",
                        value: true,
                        sales: ''
                    },
                    {
                        day: "Jueves",
                        char: "J",
                        value: true,
                        sales: ''
                    },
                    {
                        day: "Viernes",
                        char: "V",
                        value: true,
                        sales: ''
                    },
                    {
                        day: "Sábado",
                        char: "S",
                        value: true,
                        sales: ''
                    },
                    {
                        day: "Domingo",
                        char: "D",
                        value: true,
                        sales: ''
                    },
                ]
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetWeeks () {
                this.weeks = [
                    {
                        week: '1',
                        sales: ''
                    },
                    {
                        week: '2',
                        sales: ''
                    },
                    {
                        week: '3',
                        sales: ''
                    },
                    {
                        week: '4',
                        sales: ''
                    }
                ];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetBiWeeks () {
                this.biweeks= [
                    {
                        biweek: '1',
                        sales: ''
                    },
                    {
                        biweek: '2',
                        sales: ''
                    }
                ];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateProductSelect (id) {
                if (this.products[id].productSelect == 'total') {
                        var itemSum = 0;
                        for (let i=0; i<this.products[id].items.length;i++) {
                            itemSum = itemSum + this.products[id].items[i].itemValue;
                        }
                        
                        if (itemSum > this.products[id].productTotalSale) {
                            this.showNotificationError('El costo de los insumos es mayor al valor total del producto');
                            this.products[id].productSelect = 'unit';
                            return
                        }
                        else {
                            var actualProductPercent = itemSum * 100 / this.products[id].productTotalSale;
                            this.products[id].productCostPercent = actualProductPercent;
                            this.products[id].productMultiplier = 1;
                        }
                    }
                    else {
                        var itemSum = 0;
                        for (let i=0; i<this.products[id].items.length;i++) {
                            itemSum = itemSum + this.products[id].items[i].itemValue;
                        }
                        if (itemSum > this.products[id].productSaleValue) {
                            this.showNotificationError('El costo de los ítems no puede ser mayor al valor de venta');
                            this.products[id].productSelect = 'total';
                            return
                        }
                        else {
                            var actualProductPercent = itemSum * 100 / this.products[id].productSaleValue;
                            this.products[id].productCostPercent = actualProductPercent;
                            this.products[id].productMultiplier = this.products[id].productSaleMonthly;
                        }
                    }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateProductUnitCosting (row) {
                var id = this.products.indexOf(row);
                this.products[id].productSalesCosting = this.products[id].productUnitCosting * this.products[id].productSaleValue; 
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setProductSelect (val) {
                if (val == 'unit') {
                    return 'Individual'
                }
                else {
                    return 'Total'
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateLocked () {
                if (this.$store.state.productionSalesLocked) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalItemsCosting (row) {
                var id = this.products.indexOf(row);
                var sum = 0;
                for (let i=0; i< this.products[id].items.length; i++) {
                    sum = sum + (this.products[id].items[i].itemValue);
                }
                this.products[id].productTotalCosting = sum;
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalUnitCosting (row) {
                var id = this.products.indexOf(row);
                if (this.products[id].productUnitCosting != '' && this.products[id].productUnitCosting != 0) {
                    this.products[id].productUnitCost = (this.products[id].productTotalCosting / this.products[id].productUnitCosting)|| 0;
                    return this.products[id].productUnitCost
                }
                else {
                    return 0
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalCosting (row) {
                var id = this.products.indexOf(row);
                this.products[id].productTotalCost = (this.products[id].productUnitCost * this.products[id].productSaleMonthly) || 0;
                return this.products[id].productTotalCost
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.resetProduct();  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName= '';
                this.productPeriodicity= '';
                this.productSaleValue= '';
                this.productMonth= '';
                this.productSaleMonthly= '';
                this.productTotalSale= '';
                this.productSelect = 'total'
                this.productMultiplier = 1;
                this.productCostPercent= 0;
                this.checkboxes = [];
                this.weeks = [];
                this.biweeks = [];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductLineMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductLineMethod () {
                this.productName= this.currentRow.productName;
                this.productPeriodicity = this.currentRow.productPeriodicity;
                this.productMonth = this.currentRow.productMonth;
                this.productSaleValue= this.currentRow.productSaleValue;
                this.productSaleMonthly= this.currentRow.productSaleMonthly;
                this.productSelect= this.currentRow.productSelect;
                this.productMultiplier= this.currentRow.productMultiplier;
                this.checkboxes= this.currentRow.checkboxes;
                this.weeks= this.currentRow.weeks;
                this.biweeks= this.currentRow.biweeks;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productTotalSale == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].productName = this.productName;
                            this.products[index].productPeriodicity = this.productPeriodicity;
                            this.products[index].productSaleValue = this.productSaleValue;
                            this.products[index].productSaleMonthly = this.productSaleMonthly;
                            this.products[index].productMonth = this.productMonth;
                            this.products[index].productTotalSale = this.productTotalSale;
                            this.products[index].productSelect = this.productSelect;
                            this.products[index].productMultiplier = this.productMultiplier;
                            this.products[index].checkboxes = this.checkboxes;
                            this.products[index].weeks = this.weeks;
                            this.products[index].biweeks = this.biweeks;
                            this.products[index].productUnitCosting = 0;
                            this.products[index].productCostPercent = 0;
                            this.products[index].items = [];
                            this.products[index].productUnitCost = 0;
                            this.products[index].productSalesCosting = 0;
                            this.products[index].productTotalCosting = 0;
                            this.products[index].productTotalCost = 0;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.showNotificationSuccess('Producto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editItemMethod (row) {
                this.rowIndex = row;
                this.editItem = true;
                this.itemName = this.currentItemRow.itemName;
                this.itemValue = this.currentItemRow.itemValue;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeItem (row) {
                this.products[row].items.splice(this.products[row].items.indexOf(this.currentItemRow),1);
                var itemSum = 0;
                for (let i=0; i<this.products[row].items.length;i++) {
                    itemSum = itemSum + this.products[row].items[i].itemValue;
                }
                var actualProductPercent = itemSum * 100 / this.products[row].productTotalSale;
                this.products[row].productCostPercent = actualProductPercent;
                this.currentItemRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
                this.currentItemRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentItemChange(currentRow, oldCurrentRow) {
                this.currentItemRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemValue == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            if (this.products[this.addItemIndex].productSelect == 'total') {
                                var itemSum = 0;
                                for (let i=0; i<this.products[this.addItemIndex].items.length;i++) {
                                    itemSum = itemSum + this.products[this.addItemIndex].items[i].itemValue;
                                }
                                itemSum = itemSum + this.itemValue;
                                if (itemSum > this.products[this.addItemIndex].productSalesCosting) {
                                    this.showNotificationError('El costo de los ítems no puede ser mayor al valor de venta');
                                    return
                                }
                                this.products[this.addItemIndex].items.push({
                                    itemName: this.itemName,
                                    itemValue: this.itemValue
                                })
                                var itemSum = 0;
                                for (let i=0; i<this.products[this.addItemIndex].items.length;i++) {
                                    itemSum = itemSum + this.products[this.addItemIndex].items[i].itemValue;
                                }
                                var actualProductPercent = itemSum * 100 / this.products[this.addItemIndex].productSalesCosting;
                                this.products[this.addItemIndex].productCostPercent = actualProductPercent;
                                this.resetItem();
                                this.addItem = false;
                                this.addItemIndex = null;
                                this.showNotificationSuccess('Ítem agregado correctamente');
                            }
                            else {
                                var itemSum = 0;
                                for (let i=0; i<this.products[this.addItemIndex].items.length;i++) {
                                    itemSum = itemSum + this.products[this.addItemIndex].items[i].itemValue;
                                }
                                itemSum = itemSum + this.itemValue;
                                if (itemSum > this.products[this.addItemIndex].productSaleValue) {
                                    this.showNotificationError('El costo de los ítems no puede ser mayor al valor de venta');
                                    return
                                }
                                this.products[this.addItemIndex].items.push({
                                    itemName: this.itemName,
                                    itemValue: this.itemValue
                                })
                                var itemSum = 0;
                                for (let i=0; i<this.products[this.addItemIndex].items.length;i++) {
                                    itemSum = itemSum + this.products[this.addItemIndex].items[i].itemValue;
                                }
                                var actualProductPercent = itemSum * 100 / this.products[this.addItemIndex].productSaleValue;
                                this.products[this.addItemIndex].productCostPercent = actualProductPercent;
                                this.resetItem();
                                this.addItem = false;
                                this.addItemIndex = null;
                                this.showNotificationSuccess('Ítem agregado correctamente');
                            }
                            
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editItemToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemValue == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            if (this.products[this.rowIndex].productSelect == 'total') {
                                var itemSum = 0;
                                var index = this.products[this.rowIndex].items.indexOf(this.currentItemRow);
                                for (let i=0; i<this.products[this.rowIndex].items.length;i++) {
                                    if(i != index) {
                                        itemSum = itemSum + this.products[this.rowIndex].items[i].itemValue ;
                                    }
                                }
                                itemSum = itemSum + this.itemValue ;
                                if (itemSum > this.products[this.rowIndex].productTotalSale) {
                                    this.showNotificationError('El costo de los ítems no puede ser mayor al valor de venta');
                                    return
                                }
                                var index = this.products[this.rowIndex].items.indexOf(this.currentItemRow);
                                this.products[this.rowIndex].items[index].itemName = this.itemName;
                                this.products[this.rowIndex].items[index].itemValue  = this.itemValue ;
                                var itemSum = 0;
                                for (let i=0; i<this.products[this.rowIndex].items.length;i++) {
                                    itemSum = itemSum + this.products[this.rowIndex].items[i].itemValue ;
                                }
                                var actualProductPercent = itemSum * 100 / this.products[this.rowIndex].productSalesCosting;
                                this.products[this.rowIndex].productCostPercent = actualProductPercent;
                                this.resetItem();
                                this.editItem = false;
                                this.rowIndex = null;
                                this.currentItemRow = null;
                                this.$refs.itemsTable.setCurrentRow();
                                this.showNotificationSuccess('Ítem editado correctamente');
                            }
                            else {
                                var itemSum = 0;
                                var index = this.products[this.rowIndex].items.indexOf(this.currentItemRow);
                                for (let i=0; i<this.products[this.rowIndex].items.length;i++) {
                                    if(i != index) {
                                        itemSum = itemSum + this.products[this.rowIndex].items[i].itemValue ;
                                    }
                                }
                                itemSum = itemSum + this.itemValue ;
                                if (itemSum > this.products[this.rowIndex].productSaleValue) {
                                    this.showNotificationError('El costo de los ítems no puede ser mayor al valor de venta');
                                    return
                                }
                                var index = this.products[this.rowIndex].items.indexOf(this.currentItemRow);
                                this.products[this.rowIndex].items[index].itemName = this.itemName;
                                this.products[this.rowIndex].items[index].itemValue  = this.itemValue ;
                                var itemSum = 0;
                                for (let i=0; i<this.products[this.rowIndex].items.length;i++) {
                                    itemSum = itemSum + this.products[this.rowIndex].items[i].itemValue ;
                                }
                                var actualProductPercent = itemSum * 100 / this.products[this.rowIndex].productSaleValue;
                                this.products[this.rowIndex].productCostPercent = actualProductPercent;
                                this.resetItem();
                                this.editItem = false;
                                this.rowIndex = null;
                                this.currentItemRow = null;
                                this.$refs.itemsTable.setCurrentRow();
                                this.showNotificationSuccess('Ítem editado correctamente');
                            }
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName= '',
                this.itemValue = ''
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemMethod (row) {
                this.addItemIndex = row;
                this.addItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditItem () {
                this.editItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productPercent (val) {
                var sum = 0;
                var percent = 0;
                for (let i=0;i<this.products.length;i++) {
                    sum = sum + parseFloat(this.products[i].productLineTotal);
                }
                if (sum != 0) {
                    percent = Math.round(parseFloat(val) * 100 / sum);
                }
                return percent
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productPercentWithoutRound (val) {
                var sum = 0;
                var percent = 0;
                for (let i=0;i<this.products.length;i++) {
                    sum = sum + parseFloat(this.products[i].productLineTotal);
                }
                if (sum != 0) {
                    percent = parseFloat(val) * 100 / sum;
                }
                return percent
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productMonthlyValue == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            this.products.push({
                                productName: this.productName,
                                productPeriodicity: this.productPeriodicity,
                                productDaily: this.productDaily,
                                productWeekly: this.productWeekly,
                                productMonthly: this.productMonthly,
                                productMonth: this.productMonth,
                                productValue: this.productValue,
                                productMonthlyValue: this.productMonthlyValue,
                            })
                            this.resetProduct();
                            this.addProduct = false;
                            this.showNotificationSuccess('Producto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName = '';
                this.productPeriodicity = '';
                this.productSaleValue = '';
                this.productSaleMonthly = '';
                this.productMonth = '';
                this.productTotalSale = '';
                this.productSelect = '';
                this.productMultiplier = '';
                this.checkboxes = [];
                this.weeks = [];
                this.biweeks = [];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductLineMethod () {
                this.$router.push('/asessments/new_asessment/customer/costs/production/item/add_detail');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addMonth () {
                this.months.push({
                    month: String(this.months.length + 1),
                    sales: ''
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeMonth () {
                this.months.splice(this.months.length-1,1);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCostsItemGeneralSelection () {
                this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                if (this.products.length > 0) {
                    var count = 0;
                    for (let i=0;i<this.products.length;i++) {
                        if(this.products[i].items.length == 0) {
                            count = count + 1;
                        }
                    }
                    if (count != 0) {
                        this.showNotificationError('Uno o varios productos no tienen ítems, revisa y continúa');
                        return
                    }
                }
                else {
                    this.showNotificationError('No hay productos');
                    return
                }
                this.$store.dispatch('setCostsProductionItems', this.products).then(()=>{
                    this.$store.dispatch('setTotalCostsComputed', this.products_costs_monthly_average).then(()=>{
                        // if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false) {
                        //     this.$router.push('/asessments/new_asessment/customer/sales');
                        // }
                        // else {
                        //     this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                        // }
                        this.$store.dispatch('setCostsDataPopulate', true).then(()=>{
                            if(this.pyme){
                                var vm = this;
                                swal({
                                    title: '¿Deseas agregar información de Salarios?',
                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                    text: 'Si aceptas, podrás agregar o editar la información de los Salarios',
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push('/asessments/new_asessment/customer/others/salary');
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    if (dismiss == 'cancel') {
                                        swal({
                                            title: '¿Deseas agregar información de Obligaciones Financieras?',
                                            text: 'Si aceptas, podrás agregar o editar la información de las Obligaciones Financieras',
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonText: 'Si, aceptar',
                                            cancelButtonText: 'No, continuar',
                                            confirmButtonClass: 'btn btn-success btn-fill',
                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                            buttonsStyling: false
                                        }).then(() => {
                                            vm.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                                        }, function (dismiss) {
                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                            if (dismiss == 'cancel') {
                                                vm.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                            }
                                            else {
                                                swal({
                                                    title: 'Cancelado',
                                                    text: 'El analista no ha continuado',
                                                    type: 'error',
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    buttonsStyling: false
                                                })
                                            }
                                        })
                                        
                                    }
                                    else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        })
                                    }
                                })
                            }
                            else {
                                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                            }
                        });
                        
                        
                    });
                });    
            }
        },
        mounted () {
            if(this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].generalCosts.length != 0) {
                    var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo por compras, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('resetCosts').then(()=>{
                                this.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/production/general');
                        })
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem.length > 0) {
                        this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem;
                        for (let i=0; i<this.products.length; i++) {
                            if (this.products[i].productSelect == 'unit') {
                                this.products[i].productMultiplier = this.products[i].productSaleMonthly;
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].products.length > 0 && this.$store.state.productionSalesLocked) {
                        var itemProducts = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].products;
                        for (let i=0; i<this.products.length; i++) {
                            var flag = false;
                            for (let j=0; j<itemProducts.length; j++) {
                                if (this.products[i].productName == itemProducts[j].productName && this.products[i].productSaleValue == itemProducts[j].productSaleValue && this.products[i].productSaleMonthly == itemProducts[j].productSaleMonthly && this.products[i].productTotalSale == itemProducts[j].productTotalSale ) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                this.products.splice(i,1);
                                i = 0;
                            }
                        }
                        for (let i=0; i<itemProducts.length; i++) {
                            var flag = false;
                            for (let j=0; j<this.products.length; j++) {
                                if (this.products[j].productName == itemProducts[i].productName && this.products[j].productSaleValue == itemProducts[i].productSaleValue && this.products[j].productSaleMonthly == itemProducts[i].productSaleMonthly && this.products[j].productTotalSale == itemProducts[i].productTotalSale ) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                this.products.push({
                                    id: [i],
                                    productName: itemProducts[i].productName,
                                    productPeriodicity: itemProducts[i].productPeriodicity,
                                    productSaleValue: itemProducts[i].productSaleValue,
                                    productMonth: itemProducts[i].productMonth,
                                    productSaleMonthly: itemProducts[i].productSaleMonthly,
                                    productTotalSale: itemProducts[i].productTotalSale,
                                    checkboxes: itemProducts[i].checkboxes,
                                    weeks: itemProducts[i].weeks,
                                    biweeks: itemProducts[i].biweeks,
                                    productSelect: 'total',
                                    productMultiplier: 1,
                                    items: [],
                                    productCostPercent: 0,
                                    productUnitCosting: 0,
                                    productSalesCosting: 0,
                                    productTotalCosting: 0,
                                    productTotalCost: 0,
                                    productUnitCost: 0,
                                })
                                i = 0;
                            }
                            
                        }
                    }
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].generalCosts.length != 0) {
                    var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo por compras, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('resetCosts').then(()=>{
                                this.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/production/general');
                        })
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem.length > 0) {
                        this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem;
                        for (let i=0; i<this.products.length; i++) {
                            if (this.products[i].productSelect == 'unit') {
                                this.products[i].productMultiplier = this.products[i].productSaleMonthly;
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].products.length > 0 && this.$store.state.productionSalesLocked) {
                        var itemProducts = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].products;
                        for (let i=0; i<this.products.length; i++) {
                            var flag = false;
                            for (let j=0; j<itemProducts.length; j++) {
                                if (this.products[i].productName == itemProducts[j].productName && this.products[i].productSaleValue == itemProducts[j].productSaleValue && this.products[i].productSaleMonthly == itemProducts[j].productSaleMonthly && this.products[i].productTotalSale == itemProducts[j].productTotalSale ) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                this.products.splice(i,1);
                                i = 0;
                            }
                        }
                        for (let i=0; i<itemProducts.length; i++) {
                            var flag = false;
                            for (let j=0; j<this.products.length; j++) {
                                if (this.products[j].productName == itemProducts[i].productName && this.products[j].productSaleValue == itemProducts[i].productSaleValue && this.products[j].productSaleMonthly == itemProducts[i].productSaleMonthly && this.products[j].productTotalSale == itemProducts[i].productTotalSale ) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                this.products.push({
                                    id: [i],
                                    productName: itemProducts[i].productName,
                                    productPeriodicity: itemProducts[i].productPeriodicity,
                                    productSaleValue: itemProducts[i].productSaleValue,
                                    productMonth: itemProducts[i].productMonth,
                                    productSaleMonthly: itemProducts[i].productSaleMonthly,
                                    productTotalSale: itemProducts[i].productTotalSale,
                                    checkboxes: itemProducts[i].checkboxes,
                                    weeks: itemProducts[i].weeks,
                                    biweeks: itemProducts[i].biweeks,
                                    productSelect: 'total',
                                    productMultiplier: 1,
                                    items: [],
                                    productCostPercent: 0,
                                    productUnitCosting: 0,
                                    productSalesCosting: 0,
                                    productTotalCosting: 0,
                                    productTotalCost: 0,
                                    productUnitCost: 0,
                                })
                                i = 0;
                            }
                            
                        }
                    }
                }
            }
            else if(this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].generalCosts.length != 0) {
                    var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo por compras, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('resetCosts').then(()=>{
                                this.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/production/general');
                        })
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem.length > 0) {
                        this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem;
                        for (let i=0; i<this.products.length; i++) {
                            if (this.products[i].productSelect == 'unit') {
                                this.products[i].productMultiplier = this.products[i].productSaleMonthly;
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].products.length > 0 && this.$store.state.productionSalesLocked) {
                        var itemProducts = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].products;
                        for (let i=0; i<this.products.length; i++) {
                            var flag = false;
                            for (let j=0; j<itemProducts.length; j++) {
                                if (this.products[i].productName == itemProducts[j].productName && this.products[i].productSaleValue == itemProducts[j].productSaleValue && this.products[i].productSaleMonthly == itemProducts[j].productSaleMonthly && this.products[i].productTotalSale == itemProducts[j].productTotalSale ) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                this.products.splice(i,1);
                                i = 0;
                            }
                        }
                        for (let i=0; i<itemProducts.length; i++) {
                            var flag = false;
                            for (let j=0; j<this.products.length; j++) {
                                if (this.products[j].productName == itemProducts[i].productName && this.products[j].productSaleValue == itemProducts[i].productSaleValue && this.products[j].productSaleMonthly == itemProducts[i].productSaleMonthly && this.products[j].productTotalSale == itemProducts[i].productTotalSale ) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                this.products.push({
                                    id: [i],
                                    productName: itemProducts[i].productName,
                                    productPeriodicity: itemProducts[i].productPeriodicity,
                                    productSaleValue: itemProducts[i].productSaleValue,
                                    productMonth: itemProducts[i].productMonth,
                                    productSaleMonthly: itemProducts[i].productSaleMonthly,
                                    productTotalSale: itemProducts[i].productTotalSale,
                                    checkboxes: itemProducts[i].checkboxes,
                                    weeks: itemProducts[i].weeks,
                                    biweeks: itemProducts[i].biweeks,
                                    productSelect: 'total',
                                    productMultiplier: 1,
                                    items: [],
                                    productCostPercent: 0,
                                    productUnitCosting: 0,
                                    productSalesCosting: 0,
                                    productTotalCosting: 0,
                                    productTotalCost: 0,
                                    productUnitCost: 0,
                                })
                                i = 0;
                            }
                            
                        }
                    }
                }
            }
            if (this.$store.state.isCustomer) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pe_costs || null;
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                this.productValidator(product);   
            }
            else if(this.$store.state.isSpouse) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pe_costs || null;
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                this.productValidator(product);
            }
            else if(this.$store.state.isGuarantor) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pe_costs || null;
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                this.productValidator(product);
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .top-right-button {
        position: absolute;
        top: 10px; /* Ajusta el espacio desde el borde superior */
        right: 10px; /* Ajusta el espacio desde el borde derecho */
    }
</style>
